import createClient from 'openapi-fetch'
import type { paths } from '../api/generated.js'
import { apiBaseUrl } from '../api/base-url.js'

// Dedicated no-auth client for /public/* routes. The main $lib/api/client attaches
// a Bearer token and runs a 401 refresh interceptor - neither applies here since
// public routes are unauthenticated.
export const intake = createClient<paths>({
  baseUrl: apiBaseUrl(),
})

type IntakeBody = NonNullable<paths['/public/intake']['post']['requestBody']>['content']['application/json']

// Submit an intake, optionally linking it to an embed screening session by token.
// The server's /public/intake schema accepts `sessionToken`; the committed OpenAPI
// types may lag that field, so we merge it in and cast the body.
export function submitIntake(body: IntakeBody, sessionToken?: string) {
  return intake.POST('/public/intake', {
    body: (sessionToken ? { ...body, sessionToken } : body) as IntakeBody,
  })
}
